import { render, staticRenderFns } from "./BooleanCell.vue?vue&type=template&id=28fa421d&scoped=true&"
import script from "./BooleanCell.vue?vue&type=script&lang=js&"
export * from "./BooleanCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa421d",
  null
  
)

export default component.exports